import * as React from 'react';
import { useSelector } from 'react-redux';
import { ConstructionProgressHeader } from '../../../components/ConstructionProgress/ConstructionProgressHeader';
import { FavoriteButton } from '../../../components/Favorite/FavoriteButton';

import { getConstructionProgress, getDisplayName } from '../../../selectors/newbuilding';
import { HeaderCall } from '../../Call/HeaderCall';
import { FavoriteContainer } from '../../Favorite';

const CONSTRUCTION_PROGRESS_FAVORITE_EVENT_ACTIONS = {
  add: 'add_from_card_JK_buildingprogress',
  remove: 'remove_from_card_JK_buildingprogress',
};

export function ConstructionProgressHeaderContainer() {
  const constructionProgress = useSelector(getConstructionProgress);
  const name = useSelector(getDisplayName);

  if (!constructionProgress) {
    return null;
  }

  const { date } = constructionProgress;

  return (
    <ConstructionProgressHeader
      newbuildingName={name}
      date={date}
      favorite={
        <FavoriteContainer
          button={FavoriteButton}
          buttonTheme="fill_white_secondary"
          eventActions={CONSTRUCTION_PROGRESS_FAVORITE_EVENT_ACTIONS}
        />
      }
      call={<HeaderCall placeType="blockFicheringConstructionProgressHeader" eventAction="Open_buildingprogress_JK" />}
    />
  );
}
